import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Empty, Spin, message, Divider } from 'antd';
import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import { getUserExports, downloadExportFile } from '../../../services/ExportService';

const DownloadManager = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [exports, setExports] = useState([]);
  const [loading, setLoading] = useState(false);
  // const intervalRef = useRef(null);

  const fetchUserExports = async () => {
    try {
      setLoading(true);
      const data = await getUserExports();
      setExports(data.exports || []);
    } catch (error) {
      message.error('Failed to load export history');
    } finally {
      setLoading(false);
    }
  };

  const downloadExport = async (exportItem) => {
    try {
      const blob = await downloadExportFile(exportItem.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', exportItem.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      message.success('Download started');
    } catch (error) {
      message.error('Download failed');
    }
  };
  
  const getStatusDisplay = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return { color: '#52c41a', text: 'Completed' };
      case 'failed':
        return { color: '#ff4d4f', text: 'Failed' };
      case 'started':
        return { color: '#1890ff', text: 'Starting...' };
      case 'in_progress':
        return { color: '#1890ff', text: 'In Progress' };
      default:
        return { color: '#d9d9d9', text: 'Unknown' };
    }
  };

  // Poll if any export is in progress
  useEffect(() => {
    if (!isOpen) return;
    fetchUserExports(); // fetch once on open

    // intervalRef.current = setInterval(() => {
    //   const active = exports.some(exp =>
    //     ['started', 'in_progress'].includes(exp.status?.toLowerCase())
    //   );
    //   if (active) {
    //     fetchUserExports();
    //   } else {
    //     clearInterval(intervalRef.current);
    //   }
    // }, 5000);

    // return () => clearInterval(intervalRef.current);
  }, [isOpen]);

const dropdownContent = (
  <div
    style={{
      width: 400, overflow: 'auto',padding: '12px',backgroundColor: '#fdfdfd', border: '1px solid #f0f0f0',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
    }}
  >
    {/* Header */}
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 600 }}>Exported Files</h4>
      <Button 
        type="text" 
        size="small" 
        icon={<ReloadOutlined />}
        onClick={fetchUserExports}
        loading={loading}
      />
    </div>
    <Divider style={{ margin: '8px 0' }} />
    {/* Content */}
    {loading && exports.length === 0 ? (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin />
      </div>
    ) : exports.length === 0 ? (
      <Empty 
        description="No downloads yet" 
        style={{ margin: '20px 0' }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    ) : (
      exports.map((exportItem, index) => {
        const status = getStatusDisplay(exportItem.status);
        const isLast = index === exports.length - 1;

        return (
          <div key={exportItem.task_id || index}>
            {/* Export Item Row */}
            <div style={{ padding: '4px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <div style={{ fontSize: '13px' }}>
                  {exportItem.filename || 'Export file'}
                </div>
                 
                {exportItem.can_download && (
                  <Button
                    type="link"
                    size="small"
                    icon={<DownloadOutlined />}
                    onClick={() => downloadExport(exportItem)}
                    style={{ height: 'auto', fontSize: '12px', color: '#25DBCD', fontWeight: 600 }}
                  >
                    Download
                  </Button>
                )}
              </div>

              <div
                style={{display: 'flex',  alignItems: 'center',  gap: '8px', marginTop: '2px', fontSize: '11px', color: '#666' }}
              >
                <span>{String(new Date(new Date(exportItem.created_at).getTime() + (330*60000))).split("GMT")[0].slice(3)}</span>
                <span style={{ color: status.color }}>{status.text}</span>
              </div>
            </div>

            {/* Divider except after last item */}
            {!isLast && <Divider style={{ margin: '8px 0' }} />}
          </div>
        );
      })
    )}
  </div>
);

return (
  <Dropdown
    dropdownRender={() => dropdownContent}
    trigger={['click']}
    open={isOpen}
    onOpenChange={setIsOpen}
    placement="bottomRight"
  >
  <Button
    type="text"
    icon={<DownloadOutlined style={{ fontSize: '25px', color: isOpen ? '#25DBCD' : undefined }} />}
    className={`border-0 btn-icon btn-sm `}
    shape="square"
    style={{
      backgroundColor: `${isOpen ? '#EEF0FE' : ''}`, borderRadius: '10px', padding: '15px' }}
  />
  </Dropdown>
);
};
export default DownloadManager;
